<template>
  <section>
    <!-- Listing -->
    <div v-show="loading?.makeExceptions" class="listingWrapper">
      <div class="custom-spinner"><i class="fas fa-spinner fa-spin"></i></div>
    </div>
    <div class="custom-listing-wrapper">
      <div class="custom-add-button">
        <button class="btn btn-primary btn-sm" @click="addExclusion">Add</button>
      </div>
      <div v-show="!loading?.makeExceptions" ref="listingWrapper" class="listingWrapper">
        <z-table
          v-model="makeExceptions"
          class="table table-bordered table-striped"
          :is-single-row-detail="false"
          sort-on="id"
          sort-dir="asc"
          :is-header-fixed="true"
          :columns="tableColumnsName"
        >
          <template #tbody="props">
            <td class="custom-column-60">
              <a href="#" @click="editExclusion(props.row)">edit</a>
            </td>
            <td>{{ props.row.attribute }}</td>
            <td>{{ props.row.item }}</td>
            <td>{{ props.row.location }}</td>
            <td>{{ props.row.value }}</td>
            <td class="custom-column-60">
              <a href="#" @click="confirmDelete(props.row)">delete</a>
            </td>
          </template>
          <template #empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <!-- Dialogs -->
    <dialog-exclusion-make v-model="actionExclusion" @closing="closeModal" @saved="savedExclusion" />
    <confirm-delete
      v-model="actionDelete"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      @closing="closeModal"
      @proceed="performDelete"
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTable from '@/components/utilities/elements/Table.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogExclusionMake from './dialog-exclusion-make.vue'
export default {
  name: 'MakeMatrixExceptions',
  components: {
    ZTable,
    ConfirmDelete,
    DialogExclusionMake
  },
  props: {
    adasChecklistMatrixVehicle: Number
  },
  data() {
    return {
      actionExclusion: null,
      actionDelete: null,
      confirmTitle: 'Delete this Exclusion?',
      confirmAction: 'Delete',
      confirmQuestion: 'Are you sure you wish to Delete this Exclusion?'
    }
  },
  mounted() {
    this.getMakeExceptions(this.adasChecklistMatrixVehicle)
  },
  computed: {
    ...mapState(adasmatrixStore, ['makeExceptions']),
    tableColumnsName() {
      return [
        {
          field: 'adasChecklistExclusionMake',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'attribute',
          label: 'Attribute',
          sortable: false
        },
        {
          field: 'item',
          label: 'Item',
          sortable: false
        },
        {
          field: 'location',
          label: 'Location',
          sortable: false
        },
        {
          field: 'value',
          label: 'Value',
          sortable: false
        },
        {
          field: 'adasChecklistExclusionMake',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        }
      ]
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getMakeExceptions', 'saveMakeException', 'deleteMakeException', 'setException']),
    closeModal() {
      this.actionExclusion = null
      this.actionDelete = null
    },
    addExclusion() {
      this.actionExclusion = {
        adasChecklistExclusionMake: null,
        adasChecklistMatrixVehicle: this.adasChecklistMatrixVehicle,
        type: 'ADD'
      }
      this.setException({
        name: 'exception',
        value: {
          adasChecklistExclusionMake: null,
          adasChecklistMatrixVehicle: this.adasChecklistMatrixVehicle,
          item: null,
          attribute: null,
          location: null,
          value: null,
          vehicle: null
        }
      })
    },
    editExclusion(row) {
      this.actionExclusion = {
        adasChecklistExclusionMake: row.adasChecklistExclusionMake,
        adasChecklistMatrixVehicle: row.adasChecklistMatrixVehicle,
        type: 'EDIT',
        vehicle: null
      }
      this.setException({
        name: 'exception',
        value: {
          adasChecklistExclusionMake: row.adasChecklistExclusionMake,
          adasChecklistMatrixVehicle: row.adasChecklistMatrixVehicle,
          item: row.item,
          attribute: row.attribute,
          location: row.location,
          value: row.value,
          vehicle: null
        }
      })
    },
    async savedExclusion() {
      this.actionExclusion = null
      await this.getMakeExceptions(this.adasChecklistMatrixVehicle)
    },
    confirmDelete(row) {
      this.actionDelete = row
    },
    async performDelete(row) {
      this.actionDelete = null
      console.log('Deleting Exclusion', row.adasChecklistExclusionMake)
      await this.deleteMakeException(row.adasChecklistExclusionMake)
      await this.getMakeExceptions(this.adasChecklistMatrixVehicle)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-listing-wrapper {
  position: relative;
}
.listingWrapper {
  position: relative;
  margin-top: 10px;
  overflow-y: auto;
  max-height: 550px;
  width: 100%;
}
.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.1em;
}
.custom-add-button {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 15;
}
</style>
